module.exports = __webpack_public_path__ + "images/smartphone-screen-4_6aebce7eab92bd2af656c1250dc1a250.png";